module.exports = __webpack_public_path__ + "static/media/cements_india_cements.1c8b89c5.jfif";